import { useTranslation } from 'react-i18next';
import type { InsightsTotals } from '@/api/assistantInsights/assistantInsightsApi.types';
import { MetricTile } from '@/components/admin/AdminDashboard/MetricTile';
import { formatCompactNumber, formatMicroUsd, formatPercent } from './usageFormatting';

interface UsageKpiTilesProps {
  totals: InsightsTotals;
}

export function UsageKpiTiles({ totals }: UsageKpiTilesProps) {
  const { t, i18n } = useTranslation('assistant');
  const language = i18n.language;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-4">
      <MetricTile
        iconName="Wallet"
        label={t('insights.kpis.cost')}
        value={formatMicroUsd(totals.costMicroUsd, language)}
        subLabel={
          totals.projectedCostMicroUsd === null
            ? t('insights.kpis.periodEnded')
            : t('insights.kpis.projected', {
                amount: formatMicroUsd(totals.projectedCostMicroUsd, language),
              })
        }
      />
      <MetricTile
        iconName="MessageSquare"
        label={t('insights.kpis.questions')}
        value={formatCompactNumber(totals.questions, language)}
        subLabel={t('insights.kpis.activeUsers', { count: totals.activeUsers })}
      />
      <MetricTile
        iconName="Tag"
        label={t('insights.kpis.costPerQuestion')}
        value={formatMicroUsd(totals.costPerQuestionMicroUsd, language)}
        subLabel={t('insights.kpis.modelCalls', { count: totals.modelCalls })}
      />
      <MetricTile
        iconName="Zap"
        label={t('insights.kpis.cacheRate')}
        value={formatPercent(totals.cacheRate, language)}
        subLabel={t('insights.kpis.cachedTokens', {
          cached: formatCompactNumber(totals.cachedInputTokens, language),
          total: formatCompactNumber(totals.inputTokens, language),
        })}
      />
      <MetricTile
        iconName="Building"
        label={t('insights.kpis.workspaces')}
        value={formatCompactNumber(totals.activeWorkspaces, language)}
        subLabel={t('insights.kpis.tokens', {
          tokens: formatCompactNumber(totals.inputTokens + totals.outputTokens, language),
        })}
      />
    </div>
  );
}
